import axios from "axios";

import { apiDomain } from "../../store/constants";

const UserServiceHistory = {
  index(payload) {
    return axios({
      url: apiDomain + "api/customer/index",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  create(payload) {
    return axios({
      url: apiDomain + "api/customer/create",
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  save(payload) {
    return axios({
      url: apiDomain + "api/customer/store",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  show(payload) {
    return axios({
      url: apiDomain + "api/customer/" + payload.id +'/show',
      method: "GET",
      params: {
        page: payload.page,
        keyword: payload.keyword,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  update(data) {
    return axios({
      url: apiDomain + "api/customer/" + data.id +'/update',
      method: "PUT",
      data: data.payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  }
};

export default UserServiceHistory;
